import React from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';

// Services & Helpers
import API from 'API';
import FormHelper from 'helpers/FormHelper';
import TextHelpers from 'helpers/TextHelpers';
import ReferenceHelpers from 'helpers/ReferenceHelpers';
import Print from 'Print';

// Components
import Loader from 'components/common/Loader';
import SuperTable from 'components/common/SuperTable';
import EditPropertyModal from 'components/customer/EditPropertyModal';
import EditProperty from 'components/customer/EditProperty';
import EditAddress from 'components/common/EditAddress';
import DoNotCleanModal from 'components/customer/DoNotCleanModal';
import CustomerCommList from 'components/customer/CustomerCommunication/CustomerCommList';
import ApptList from 'components/customer/ApptList';
import PriceCalcModal from 'components/appt/PriceCalcModal';
import DedupeCustomerModal from 'components/customer/DedupeCustomerModal';
import MovePropertyModal from 'components/customer/MovePropertyModal';
import RebookList from 'components/customer/RebookList';

//-----------------------------------------------------------------

class EditCustomerModal extends React.Component {

    constructor(props) {
        super(props);

        this.editPropertyModalRef = React.createRef();
        this.doNotCleanModalRef = React.createRef();
        this.priceCalcModalRef = React.createRef();
        this.dedupeCustomerModalRef = React.createRef();
        this.movePropertyModalRef = React.createRef();
        this.rebookListRef = React.createRef();

        this.state = {
            customerRebooks: { rebooks: [] },
            nextRebookDate: null
        };
        
        //this.onAddNewRebookSave = this.onAddNewRebookSave.bind(this);
        
        this.changedFields = {};
        this.form = new FormHelper({
            fields: {
                title: {
                    label: 'Title',
                    type: 'text'
                },
                firstName: {
                    label: 'First Name',
                    type: 'text'
                },
                lastName: {
                    label: 'Last Name',
                    type: 'text'
                },
                companyName: {
                    label: 'Company Name',
                    type: 'text'
                },
                landlineTel: {
                    label: 'Landline Number',
                    type: 'tel'
                },
                mobileTel: {
                    label: 'Mobile Number',
                    type: 'tel'
                },
                hasMultipleProperties: {
                    label: 'Multiple Properties',
                    boxLabel: '',
                    type: 'checkbox',
                    isReadOnly: () => this.state.properties && this.state.properties.length > 1
                },
                secondaryTel: {
                    label: 'Secondary Phone Number',
                    type: 'tel'
                },
                emailAddress: {
                    label: 'Email Address',
                    type: 'email'
                },
                type: {
                    label: 'Type',
                    type: 'single-select',
                    getOptions: () => ReferenceHelpers.CustomerTypes
                },
                customerSourceID: {
                    label: 'Source',
                    type: 'single-select',
                    blankText: '(Select)',
                    getOptions: () => this.state.customerSources.map(cs => ({
                        value: cs.id,
                        text: cs.name
                    }))
                },
                doNotCleanReason: {

                },
                notes: {
                    label: 'Customer Notes',
                    type: 'expanding-text',
                    rows: 1
                },
                reference: {
                    label: 'Unique Reference (for searching)',
                    type: 'text'
                },
                dontAutoInvoice: {
                    label: 'Invoice Manually',
                    boxLabel: '',
                    type: 'checkbox'
                }
            },
            getValue: (fieldName) => this.state.customer[fieldName],
            onBlur: (fieldName, value, fieldInfo) => {
                if (fieldName == 'lastName') {
                    this.checkForExistingRecord();
                }
            },
            setValue: (fieldName, value) => this.updateFields({ [fieldName]: value })
        });
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            
            this.setState({
                isOpen: true,
                isLoading: true,
                id: opt.id,
                propertyID: opt.propertyID,
                cameFrom: opt.cameFrom,
                customerRebooks: { rebooks: []}
            }, () => {
                this.load();
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }
    
    async load(silent) {
        return new Promise(async (resolve, reject) => {
            const { id } = this.state;
            let customer;

            if (id) {
                if (!silent) {
                    this.setState({ isLoading: true });
                }
                customer = await API.call(`customer/get/${id}`);
                if (!customer) {
                    alert('Sorry, the customer could not be found');
                    this.close();
                    return;
                }                
            } else {
                customer = {
                    type: 'Domestic',
                    billingAddress: {},
                    property: {
                        address: {},
                        cookers: []
                    }
                };
            }

            // Load related entities
            const customerSources = await API.call('customer-source/list');

            // Update UI
            this.setState({
                isLoading: false,
                isLoadingProperties: true,
                customer,
                customerSources,
            }, async () => {

                this.loadProperties(resolve);

            });
        });
    }

    async loadProperties(callback) {
        const { customer, propertyID } = this.state;
        this.setState({ isLoadingProperties: true });
        
        let properties = [];
        if (customer.id) {
            properties = await API.call('property/list', { customerID: customer.id });
        }

        // Multiple properties
        if (customer.hasMultipleProperties) {
            this.setState({
                properties,
                isLoadingProperties: false
            }, () => {
                if (propertyID) {
                    this.editProperty(propertyID);
                }
                if (callback) callback();
            });
        }
        // Single property
        else {
            let property = {};
            if (propertyID) {
                property = await API.call('property/get/' + propertyID);
            }
            else if (properties.length > 0) {
                property = await API.call('property/get/' + properties[0].id);
            }

            // Update on customer
            this.updateFields({
                property
            }, () => {
                this.setState({
                    isLoadingProperties: false
                }, callback);
            });
        }
    }
    
    async save() {
        return new Promise(async (resolve) => {
            try {
                let { customer } = this.state;
                this.setState({ isLoading: true });
                this.changedFields = {};
                const id = await API.call('customer/save', customer);
                resolve({ action: 'save', id });
            } catch (error) {
                alert(error);
            } finally {
                this.setState({ isLoading: false });
            }
        });
    }

    async saveAndReload() {
        const { id } = await this.save();
        this.setState({
            id
        }, () => {
            this.load();
        });
    }

    async saveAndClose() {
        const result = await this.save();
        this.close();
        this.resolve(result);
    }

    updateFields(fields, callback) {
        const customer = { ...this.state.customer };
        let loadProperties;

        for (let fieldName in fields) {
            const oldValue = customer[fieldName];
            const value = fields[fieldName];
            customer[fieldName] = value;
            this.changedFields[fieldName] = true;

            // Load properties if switching between single property and multiple properties
            if (fieldName == 'hasMultipleProperties') {
                loadProperties = true;
                if (value) {
                    this.setState({ propertyID: null });
                }
            }
        }
        this.setState({
            customer,
            isLoadingProperties: loadProperties
        }, () => {
            if (loadProperties) {
                this.loadProperties(callback);
            } else if (callback) {
                callback();
            }
        });
    }

    updateBillingAddressFields(fields, callback) {
        const billingAddress = { ...this.state.customer.billingAddress };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            billingAddress[fieldName] = value;
        }
        this.updateFields({ billingAddress }, callback);
    }

    updatePropertyFields(fields, callback) {
        const property = { ...this.state.customer.property };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            property[fieldName] = value;
        }
        this.updateFields({ property }, callback);
    }

    async addProperty() {
        const { customer } = this.state;
        let customerID = customer.id;
        if (!customerID) {
            const { id } = await this.save();
            customerID = id;
            this.setState({ id });
        }
        await this.editPropertyModalRef.current.open({
            customerID
        });
        this.setState({ propertyID: null });
        this.load(true);
    }
    
    async editProperty(id) {
        const { customer } = this.state;
        await this.editPropertyModalRef.current.open({
            customer,
            id
        });
        this.setState({ propertyID: null });
        this.loadProperties();
    }

    async showDoNotCleanModal() {
        const { id, doNotCleanReason } = this.state.customer;
        await this.doNotCleanModalRef.current.open({
            customerID: id,
            reason: doNotCleanReason
        });
        this.load();
    }

    async confirmToggleIsArchived() {
        const { id, isArchived } = this.state.customer;
        const confirm = window.confirm((isArchived ? 'Un-archive' : 'Archive') + ' this customer?');
        if (confirm) {
            await API.call('customer/set-is-archived', {
                customerID: id,
                isArchived: !isArchived
            });
            this.updateFields({
                isArchived: !isArchived
            });
            if (!isArchived) {
                this.close();
                this.resolve({ action: 'archive' });
            }
        }
    }

    async confirmDelete() {
        const { customer } = this.state;
        let confirm = window.confirm('Are you sure you want to delete this customer?');
        if (confirm) {
            this.setState({ isLoading: true });

            // Check for any open appts and warn again if there are any
            const openAppts = await API.call('appt/list', {
                customerID: customer.id,
                status: 'Open'
            });
            if (openAppts.length > 0) {
                confirm = window.confirm('The customer has ' +  openAppts.length + ' appointment(s) still open. Are you absolutely sure you want to delete them?');
            }

            if (confirm) {
                await API.call('customer/delete/' + customer.id);
                this.close();
                this.resolve({ action: 'delete' });
            } else {
                this.setState({ isLoading: false });
            }
        }
    }

    async addAppt() {
        const { id } = await this.save();
        this.close();
        this.props.history.push(`/calendar?customerID=${id}`);
    }

    confirmResendCompletedNotification() {
        const confirm = window.confirm('Re-send the completion email?');
        if (confirm) {
            this.resendCompletedNotification();
        }
    }

    async resendCompletedNotification() {
        await API.call('appt/trigger-notification', {
            apptID: this.state.customer.property.latestApptID,
            type: 'ApptCompleted'
        });
        alert('The notification has been sent.');
    }

    showPriceCalcModal() {
        this.priceCalcModalRef.current.open({});
    }

    async switchAccount(accountID) {
        const { loginInfo } = this.props;
        const { id } = await this.save();
        this.setState({ isLoading: true });
        await API.call('customer/switch-account', {
            customerID: id,
            accountID
        });
        const account = loginInfo.accounts.find(a => a.accountID == accountID);
        window.location.href = `/${account.accountCode}/customers/active?customerID=${id}`;
    }

    async showDedupeModal() {
        await this.dedupeCustomerModalRef.current.open({
            customerID: this.state.customer.id
        });
        this.close();
        this.resolve({ action: 'dedupe' });
    }

    async showMovePropertyToOtherCustomerModal() {
        await this.movePropertyModalRef.current.open({
            id: this.state.customer.property.id
        });
        this.load();
    }

    async checkForExistingRecord() {
        const { customer } = this.state;
        if (!customer.id && customer.lastName) {
            let postcode = customer.property?.address?.postcode;
            if (postcode) {
                postcode = TextHelpers.normalisePostcode(postcode);
                const existingProperty = await API.call('customer/find-existing-property', {
                    //customerID: customer.id,
                    lastName: customer.lastName,
                    postcode
                });
                if (existingProperty && window.confirm('An existing customer record was found with this surname and postcode. Do you want to switch to it?')) {
                    this.changedFields = {};
                    this.setState({
                        id: existingProperty.customerID,
                        propertyID: existingProperty.id,
                        isLoading: true
                    }, () => this.load());
                }
            }
        }
    }

    //--------------------------------------------------------------------------

    render() {
        const { 
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }
       
        return (<>
            <Modal show onHide={() => this.close()} className="edit-customer-modal" backdrop="static">
                <form onSubmit={e => { e.stopPropagation(); e.preventDefault(); this.saveAndClose() }}>
                    <Modal.Header>
                        {this.renderControls(true)}
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderInner()}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderControls(false)}
                    </Modal.Footer>
                </form>
            </Modal>

            <PriceCalcModal ref={this.priceCalcModalRef} />
            <DedupeCustomerModal ref={this.dedupeCustomerModalRef} />

        </>);
    }
    
    renderRebooksSection() {
        
    }
    
    renderInner() {
        const {
            isLoading,
            isLoadingProperties,
            customer,
            cameFrom
        } = this.state;
        const { history } = this.props;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            {!!customer.doNotCleanReason &&
                <section className="warning mb-3">
                    <span className="fa-solid fa-triangle-exclamation" />{' '}
                    DO NOT CLEAN: {customer.doNotCleanReason}
                </section>
            }
            {customer.isArchived &&
                <section className="warning mb-3">
                    <span className="fa-solid fa-box-archive" />{' '}
                    This customer is archived
                </section>
            }
            {customer.isDeleted &&
                <section className="warning mb-3">
                    <span className="fa-solid fa-box-archive" />{' '}
                    This customer record is deleted. Save the customer record to un-delete it.
                </section>
            }

            <div className="row">

                <div className="col-md-6">

                    <section>

                        <h2>Customer Details</h2>

                        {this.renderCustomerDetails()}

                    </section>

                    {!!customer.id && customer.property &&
                        <CustomerCommList
                            customerID={customer.id}
                            propertyID={customer.property.id}
                            customerRebooks={this.state.customerRebooks}
                            defaultType={cameFrom == 'rebooks' ? 'Call' : 'Note'}
                            onAdd={async () => {
                                if (cameFrom == 'rebooks') {
                                    this.close();
                                    this.resolve({ action: 'add-customer-comm' });
                                } else if (this.rebookListRef.current) {
                                    this.rebookListRef.current.load();
                                }
                            }}
                        />
                    }

                </div>

                <div className="col-md-6">

                    <section>

                        {isLoadingProperties ? <Loader /> :
                            (customer.hasMultipleProperties ?
                                this.renderMultiProperty() :
                                this.renderSingleProperty()
                            )
                        }

                    </section>

                    {!customer.hasMultipleProperties && !!customer.id && customer.property &&
                        <RebookList
                            ref={this.rebookListRef}
                            customerID={customer.id}
                            propertyID={customer.property.id}
                            onChange={() => this.load()}
                        />
                    }

                    {!!customer.id && customer.property && !customer.hasMultipleProperties &&
                        <ApptList
                            {...this.props}
                            customerID={customer.id}
                            propertyID={customer.property.id}
                        />
                    }
                    {/*hideButtons={cameFrom == 'appt'}*/}

                </div>

            </div>

            <EditPropertyModal
                history={history}
                ref={this.editPropertyModalRef}
                cameFrom={cameFrom}
                onSwitch={accountID => this.switchAccount(accountID)}
                onAddNewRebookSave={this.onAddNewRebookSave}
                {...this.props}
            />
            <DoNotCleanModal ref={this.doNotCleanModalRef} />
            <MovePropertyModal ref={this.movePropertyModalRef} />
        </>);
    }

    renderControls(showTitle) {
        const { isLoading, customer, cameFrom } = this.state;
        if (isLoading) return null;

        let title = 'New Customer';
        if (customer.id) {
            if (customer.type == 'Domestic' || !customer.companyName) {
                title = TextHelpers.formatName(customer.title, customer.firstName, customer.lastName);
            } else {
                title = customer.companyName;
            }
            if (customer.reference) {
                title += ` (${customer.reference})`;
            }
        }

        return (<>

            <button type="button" className="btn btn-secondary me-3" onClick={() => this.close()}>
                Cancel
            </button>

            {/*
            <button type="button" className="btn btn-secondary me-auto" onClick={() => this.showPriceCalcModal()}>
                <span className="icon fa-regular fa-clipboard" />{' '}Quotation
            </button>
            */}
            {showTitle &&
                <Modal.Title>
                    {title}
                </Modal.Title>
            }

            <div className="ms-auto">

                {!!customer.id && <>

                    <div className="dropdown me-3">
                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            More...
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <a className="dropdown-item" href="#" onClick={e => {
                                    e.preventDefault();
                                    this.showDoNotCleanModal();
                                }}>
                                    <span className="fa-solid fa-ban" />{' '}
                                    Do not clean
                                </a>
                            </li>
                            <li>
                                <a className="dropdown-item" href="#" onClick={e => {
                                    e.preventDefault();
                                    this.confirmToggleIsArchived();
                                }}>
                                    <span className="fa-solid fa-box-archive" />{' '}
                                    {customer.isArchived ? 'Un-archive' : 'Archive'}
                                </a>
                            </li>
                            <li>
                                <a className="dropdown-item" href="#" onClick={e => {
                                    e.preventDefault();
                                    this.confirmDelete();
                                }}>
                                    <span className="fa-solid fa-trash" />{' '}
                                    Delete
                                </a>
                            </li>
                            {!!customer.id &&
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => {
                                        e.preventDefault();
                                        this.showDedupeModal();
                                    }}>
                                        <span className="fa-solid fa-copy" />{' '}
                                        De-duplicate
                                    </a>
                                </li>
                            }
                            {customer.property && 
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => {
                                        e.preventDefault();
                                        this.showMovePropertyToOtherCustomerModal();
                                    }}>
                                        <span className="fa-solid fa-right-to-bracket" />{' '}Move property to different customer
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                </>}

                <button type="type" className="btn btn-secondary me-3" onClick={() => this.addAppt()}>
                    Add Appointment
                </button>

                <button type="type" className="btn btn-secondary me-3" onClick={() => this.saveAndReload()}>
                    Save
                </button>

                <button type="submit" className="btn btn-primary">
                    Save & Close
                </button>

            </div>
        </>);
    }

    renderCustomerDetails() {
        const { customer } = this.state;

        return (<>

            <div className="row">

                <div className="col-md-2">

                    {this.form.render('title')}

                </div>

                <div className="col-md-3">

                    {this.form.render('firstName')}

                </div>

                <div className="col-md-3">

                    {this.form.render('lastName')}

                </div>

                <div className="col-md-4">

                    {this.form.render('type')}

                </div>

            </div>

            {customer.type == 'Business' && this.form.render('companyName')}

            <div className="row">

                <div className="col-md-4">

                    {this.form.render('customerSourceID')}

                </div>

                <div className="col-md-4">

                    {this.form.render('mobileTel')}

                </div>

                <div className="col-md-4">

                    {this.form.render('hasMultipleProperties')}

                </div>
                
            </div>

            <div className="row">

                <div className="col-md-4">

                    {this.form.render('landlineTel')}

                </div>

                <div className="col-md-4">

                    {this.form.render('emailAddress')}

                </div>

                <div className="col-md-4">

                    {this.form.render('secondaryTel')}

                </div>

            </div>

            <div className="row">

                <div className="col-md-8">

                    {this.form.render(['notes'])}

                </div>

                <div className="col-md-4">

                    {this.form.render(['dontAutoInvoice'])}

                </div>

            </div>
            
        </>);
    }

    renderSingleProperty() {
        const { customer } = this.state;

        return (<>

            <h2>
                Property Details
            </h2>

            <EditProperty
                {...this.props}
                property={customer.property || {}}
                updateFields={(fields, callback) => this.updatePropertyFields(fields, callback)}
                onSwitch={accountID => this.switchAccount(accountID)}
                onBlurPostcode={() => this.checkForExistingRecord()}
                onReload={() => this.load()}
            />

        </>);
    }

    renderMultiProperty() {
        const {
            customer,
            properties
        } = this.state;

        return (<>
            <h2>
                Billing Address
            </h2>

            <EditAddress
                address={customer.billingAddress || {}}
                updateFields={(fields, callback) => this.updateBillingAddressFields(fields, callback)}
            />

            <h2 className="mt-3">
                Properties

                <button type="button" className="ms-auto btn" onClick={() => this.addProperty()}>
                    <span className="fa-solid fa-plus" />{' '}
                    Add Property
                </button>
            </h2>

            {/* TODO move style into css */}
            <div className="sticky-table-container" style={{
                maxHeight: 'calc(100vh - 485px)'
            }}>
                <SuperTable
                    className="customer-properties-table table table-bordered clickable mb-0"
                    rows={properties}
                    keyAccessor={property => property.id}
                    cols={{
                        name: {
                            label: 'Name'
                        },
                        tenantName: {
                            label: 'Tenant'
                        },
                        rebook: {
                            label: 'Rebook',
                            getValue: (col, property) =>
                                Object.keys(property.rebookMonths).map(m => moment().month(m-1).format('MMM')).join(', ')
                        }
                    }}
                    onClick={(property, e, index) => this.editProperty(property.id)}
                    emptyText="No properties added"
                />
            </div>
        </>);
    }
}

export default EditCustomerModal;